// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TeamEditPopup.css */
.popupOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popupContent {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  color: black;
  max-height: 90vh;
  overflow: auto;
}

.popupContent h3 {
  margin-bottom: 10px;
}

.popupContent input {
  width: calc(100% - 20px);
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.popupContent button {
  padding: 10px 15px;
  border: none;
  background: #007bff;
  color: white;
  cursor: pointer;
  border-radius: 4px;
}

.popupContent button:last-child {
  background: #dc3545;
}

.popupContent h4 {
  margin: 8px 0;
}

.popupContent .playerHeader {
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  padding: 4px;
  padding-left: 8px;
  color: white;
}

.popupContent .playerHeader p {
  font-size: 14px;
}

.popupContent .playerHeader button {
  padding: 8px;
}

.popupContent .playersList {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.popupContent .playerDetails {
  padding: 8px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.playerDetails input{
  margin: 0;
  margin-bottom: 8px;
}

.popupContent .playerDetails label{
  width: 100%;
  text-align: start;
  padding-left: 8px;
  padding-bottom: 4px;
  color: white;
  font-size: 14px;
}

.popupContent .playersList div {
  background-color: #07263b;
  border-radius: 4px;
}

.popupContent .cancelBtn,
.popupContent .saveBtn {
  margin-top: 16px;
}

.popupContent .cancelBtn{
  margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/AdminDashboard/Tournament/TeamEditPopup.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,uCAAuC;EACvC,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* TeamEditPopup.css */\r\n.popupOverlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.popupContent {\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  width: 400px;\r\n  max-width: 90%;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\r\n  color: black;\r\n  max-height: 90vh;\r\n  overflow: auto;\r\n}\r\n\r\n.popupContent h3 {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.popupContent input {\r\n  width: calc(100% - 20px);\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n}\r\n\r\n.popupContent button {\r\n  padding: 10px 15px;\r\n  border: none;\r\n  background: #007bff;\r\n  color: white;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n}\r\n\r\n.popupContent button:last-child {\r\n  background: #dc3545;\r\n}\r\n\r\n.popupContent h4 {\r\n  margin: 8px 0;\r\n}\r\n\r\n.popupContent .playerHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  justify-content: space-between;\r\n  padding: 4px;\r\n  padding-left: 8px;\r\n  color: white;\r\n}\r\n\r\n.popupContent .playerHeader p {\r\n  font-size: 14px;\r\n}\r\n\r\n.popupContent .playerHeader button {\r\n  padding: 8px;\r\n}\r\n\r\n.popupContent .playersList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.popupContent .playerDetails {\r\n  padding: 8px;\r\n  padding-bottom: 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.playerDetails input{\r\n  margin: 0;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.popupContent .playerDetails label{\r\n  width: 100%;\r\n  text-align: start;\r\n  padding-left: 8px;\r\n  padding-bottom: 4px;\r\n  color: white;\r\n  font-size: 14px;\r\n}\r\n\r\n.popupContent .playersList div {\r\n  background-color: #07263b;\r\n  border-radius: 4px;\r\n}\r\n\r\n.popupContent .cancelBtn,\r\n.popupContent .saveBtn {\r\n  margin-top: 16px;\r\n}\r\n\r\n.popupContent .cancelBtn{\r\n  margin-left: 8px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
